import { createFetch } from './fetchApi'
import { currentLang } from '@/composables/settings/storage'
import { handleStatus } from '@/composables/exception/handler'
import { currentUser } from '@/composables/user/users'
import { isInWechat } from '@/utils/device'
import { STORAGE_KEY_CLIENT_TYPE } from '@/constants'
import { getAppHost, getDefaultAvatarId } from '@/utils/config'
import type { Ref } from 'vue'
import { tryUseNuxtApp } from '#app'

export const MAX_TIMEOUT = 60000
const MAX_UPLOAD_TIMEOUT = 1000 * 60 * 20 // 20 minutes

// user api
export const USER_SEND_CODE = '/v1/user:sendCode'
export const USER_REGISTER = '/v1/user:register'
export const USER_REFRESH_TOKEN = '/v1/user:refreshToken'
export const USER_LOGIN = '/v1/user:login'
export const USER_LOGIN_BY_CODE = '/v1/user:loginByCode'
export const USER_LOGOUT = '/v1/user:logout'
export const USER_SET_PASSWORD = '/v1/user:setPassword'
export const USER_MODIFY_PASSWORD = '/v1/user:modifyPassword'
export const USER_PROFILE = '/v1/user/profile'
export const USER_SET_NAME = '/v1/user:setName'
export const USER_SET_LANG = '/v1/user:setLang'
export const USER_SET_AVATAR = '/v1/user:setAvatar'
export const USER_BIND_PHONE = '/v1/user:bindPhone'
export const USER_CHANGE_PHONE = '/v1/user:changePhone'
export const USER_SET_SOURCE = '/v1/user:setSource'
export const USER_DESTROY_ACCOUNT = '/v1/user:destroy'

// wechat api
export const WECHAT_GET_AUTHURL = '/v1/wechat/authUrl'
export const WECHAT_LOGIN = '/v1/wechat:login'
export const WECHAT_MINIAPP_LOGIN = '/v1/wechat/miniapp:login'
export const WECHAT_BIND = '/v1/wechat:bind'
export const WECHAT_UNBIND = '/v1/wechat:unbind'
export const WECHAT_URL_SIGN = '/v1/wechat:signUrl'
export const WECHAT_BOUND_QRCODE = '/v1/wechat/qrcode/default'
export const WECHAT_LOGIN_QR = '/v1/wechat/loginQr'
export const WECHAT_LOGIN_QR_CALLBACK = '/v1/wechat/authCallback'
export const WECHAT_CHECK_QR_CHECK = '/v1/wechat/checkQrScan'

export const WECHAT_TEMP_QR = '/v1/wechat:qrTempBind'

// miniprogram api
export const MINI_PROGRAM_GET_VERSION = '/v1/config/miniapp'

// media api
export const MEDIA_UPLOAD_AVATAR = '/v1/media:uploadAvatar'
export const MEDIA_UPLOAD_IMAGE = '/v1/media:uploadImage'
export const MEDIA_UPLOAD_FILE = '/v1/media:uploadFile'
export const MEDIA_CHECK_CAP = '/v1/media:checkStorageCap'
export const MEDIA_STS_TOKEN = '/v1/media:stsToken'
export const MEDIA_UPLOAD_IMAGE_BY_URL = '/v1/media:downloadImageFromUrl'
export const MEDIA_RESIZE = '/v1/media:resize'
// home
export const HOME_GET = '/v1/home'
export const HOME_COUPON_DOCKS = '/v1/coupon/docks'
export const GET_COUPON = '/v1/coupon:getCoupon'
export const GET_COUPON_BY_SCENE = '/v1/coupon:getByScene'
export const GIVE_COUPON_By_SECNE = '/v1/coupon:giveByScene'

// life api

//article
export const ARTICLE_GET_BY_ID = '/v1/article/{id}'
export const ARTICLE_PUBLISH = '/v1/article/publish'

// export const LIFE_CREATE = '/v1/life:create'
export const LIFE_CREATE_IN_ONE = '/v1/life:createInOne'
//export const LIFE_EDIT = '/v1/life:edit'
export const LIFE_EDIT_IN_ONE = '/v1/life:editInOne'
export const LIFE_SET_OPEN_TO_PUB = '/v1/life:setOpen'

export const LIFE_SET_BASE_INFO = '/v1/life:setBaseInfo'
export const LIFE_LIST = '/v1/lifes'
export const LIFE = '/v1/life'
export const LIFE_DETAIL = '/v1/life/detail'
export const LIFE_GET_BY_SERVICE_ID = '/v1/life:getByServiceId'
export const LIFE_ARCHIVE = '/v1/life:archive'
export const LIFE_RECOVER = '/v1/life:recover'
export const LIFE_CAP = '/v1/life:checkCap'
export const LIST_FAVORITE_LIFE = '/v1/life/favorites'
export const SEARCH_FAVORITE_LIFE = '/v1/life/openSearch'
export const VISIT_OPEN_LIFE = '/v1/statistic/memorial/visits'

export const LIFE_SET_CONFIG = '/v1/life:setConfig'
export const LIFE_SET_AVATAR = '/v1/life:setAvatar'

// service api
export const SERVICE_BASE = '/v1/m/service'

export const ARTICLE_MESSAGES = '/v1/m/articleAndMessages'
export const ARTICLE_SET_TOP = '/v1/m/article:setTop'
export const OBITUARY_SET_TOP = '/v1/obituary:setTop'
export const OBITUARY_SET_HIDE = '/v1/obituary:setHide'
// memorial article
export const MEMORIAL_ARTICLE_CREATE = '/v1/m/article:create'
export const MEMORIAL_ARTICLE = '/v1/m/article'
export const MEMORIAL_ARTICLE_EDIT = '/v1/m/article:edit'
export const MARTICLE_TEMPLATES = '/v1/m/marticletpls'

// memorial message
export const MEMORIAL_GIFT_LIST = '/v1/m/gifts'
export const MEMORIAL_ADD_PRELOAD = '/v1/m/addMemoryPreload'
export const MEMORIAL_MESSAGE_CREATE = '/v1/m/message:create'
export const MEMORIAL_MESSAGE_LIST = '/v1/m/messages'
export const MEMORIAL_MESSAGE = '/v1/m/message'
export const MEMORIAL_COMMENT_THANKS = '/v1/m/message:thanks'

// memorial post
export const MEMORIAL_POST_ADD_PHOTO = '/v1/m/post/{type}:create'
export const MEMORIAL_POST_LIST_PHOTO = '/v1/m/post/photos'
export const MEMORIAL_LIST_PHOTO_FILE = '/v1/m/file/{type}s'
export const MEMORIAL_POST = '/v1/m/post'
export const MEMORIAL_POST_PRE_LOAD = '/v1/m/post/preload'

// memorial claim / report
export const MEMORIAL_REPORT = '/v1/m:report'
export const MEMORIAL_CLAIM = '/v1/m:claim'

// life file
export const LIFE_FILE_EDIT_DESC = '/v1/m/lifeFile:editDesc'

// story post
export const MEMORIAL_STORY_ADD = '/v1/m/post/story:create'
export const MEMORIAL_STORY_LIST = '/v1/m/post/storys'

export const MEMORIAL_ADD_ONE_LIFE_PRELOAD = '/v1/m/lifeArticle/addOnePreload'
export const MEMORIAL_ADD_LIFE_ARTICLE = '/v1/m/lifeArticle:create'
export const MEMORIAL_LIST_LIFE_ARTICLE = '/v1/m/lifeArticles'
export const MEMORIAL_LIFE_ARTICLE = '/v1/m/lifeArticle'
export const MEMORIAL_EDIT_LIFE_ARTICLE = '/v1/m/lifeArticle:edit'

// invitation
export const MEMORIAL_INVITATION_CREATE = '/v1/m/invitation:create'
export const MEMORIAL_INVITATION_ACCEPT = '/v1/m/invitation:accept'
export const MEMORIAL_INVITATION = '/v1/m/invitation/'

// privileges
export const SERVICE_PRIVILEGES = '/v1/m/{serviceId}/privileges'
export const SERVICE_PRIVILEGE_CHANGE = '/v1/m/{serviceId}/privilege:change'
export const SERVICE_PRIVILEGE_DELETE = '/v1/m/{serviceId}/privilege'
// sayto
export const SAYTO_CREATE = '/v1/sayto/msg:create'
export const SAYTO_LIST = '/v1/sayto/msgs'
export const SAY_TO_BASE = '/v1/sayto/msg/'

// schedule
export const SCHEDULE_SETTING_CREATE = '/v1/schedule/setting:create'
export const SCHEDULE_SETTINGS = '/v1/schedule/settings'
export const SCHEDULE_ANNIVERSARY = '/v1/schedule/anniversaries'
export const SCHEDULE_ADD = '/v1/schedule/setting:add'
export const SCHEDULE_LIST_GROUPS = '/v1/schedule/anniversary/groups'

// notification
export const NOTIFICATION_LIST = '/v1/notifications'
export const NOTIFICATION_BASE = '/v1/notification'
export const NOTIFICATION_SET_READ = '/v1/notification:setRead'
export const NOTIFICATION_SET_LIST_READ = '/v1/notification:setListRead'
export const NOTIFICATION_SET_ALL_READ = '/v1/notification:setAllRead'
export const NOTIFICATION_COUNT = '/v1/notification:count'

// history
export const HISTORY_LIST = '/v1/historys'

// membership
export const MEMBER_PRE = '/v1/member/pre'
export const MEMBER_CREATE_ORDER_WECHATJS = '/v1/member/order:createWechat'
export const MEMBER_CREATE_ORDER_WECHATQR = '/v1/member/order:createWechatNative'

export const MEMBER_CHECK_NATIVE_ORDER = '/v1/member/order:checkNativePaid'
export const MEMBER_ORDERS = '/v1/member/orders'
export const MEMBER_CHECK_QR = '/v1/pay/order:checkNativePaid'

// theme
export const THEME_PRE_GET = '/v1/m/theme/pre'
export const THEME_SELECT = '/v1/m/service:setTheme'

// gift
export const GIFT_LIST = '/v1/m/gifts'

// coin
export const COIN_ACCOUNT = '/v1/coin/account'
export const COIN_JS_ORDER = '/v1/coin/order:createWechat'
export const COIN_QR_ORDER = '/v1/coin/order:createWechatNative'
export const COIN_QR_PAY_CHECK = '/v1/coin/order:checkNativePaid'
export const COIN_TRADE_LIST = '/v1/coin/trade'

// album
export const ALBUM_CREATE = '/v1/album:create'
export const ALBUM_MODIFY = '/v1/album:modifyDesc'
export const ALBUM_RENAME = '/v1/album:rename'
export const ALBUM_LIST = '/v1/albums'
export const ALBUM_PATH = '/v1/album/{folderId}'
export const ALBUM_FILE = '/v1/album'
export const ALBUM_ADD_FILE_PRE = '/v1/album/pre'
export const ALBUM_FILE_LIST = '/v1/album/files'
export const ALBUM_FLLE_ADD = '/v1/album/file:add'
export const ALBUM_UPLOAD = '/v1/album:upload'
export const ALBUM_SET_FOLDER = '/v1/album/file:setFolder'
export const ALBUM_SET_YEAR = '/v1/album/file:setYear'
export const ALBUM_SORT_FILE = '/v1/album/file:sort'

// obituary
export const OBITUARY_CREATE_PREVIEW = '/v1/obituary:generateMsg'
export const OBITUARY_STYLES = '/v1/obituary/preset/obituaryStyles'
export const OBITUARY_PREVIEW = '/v1/obituary:preview'
export const OBITUARY_PUBLISH = '/v1/obituary:publish'
export const OBITUARY_DETAILS = '/v1/obituary/{id}'
export const OBITUARY_DELETE = '/v1/obituary/{id}'

export const OBITUARY_CREATE_WREATH_ORDER_NATIVE = '/v1/obituary/wreath:createOrderNative'
export const OBITUARY_CREATE_WREATH_ORDER_JS = '/v1/obituary/wreath:createOrderJS'
export const OBITUARY_CREATE_COUPLET_ORDER_NATIVE = '/v1/obituary/couplet:createOrderNative'
export const OBITUARY_CREATE_COUPLET_ORDER_JS = '/v1/obituary/couplet:createOrderJS'
export const OBITUARY_CHECK_NATIVE_ORDER = '/v1/obituary/order:checkNativePaid'
export const OBITUARY_LIST_WREATH_SENT = '/v1/obituary/{obituaryId}/wreaths'
export const OBITUARY_LIST_COUPLET_SENT = '/v1/obituary/{obituaryId}/couplets'
export const REPORT_PV = '/v1/stat/pv:report'

export const OBITUARY_WREATH_THANKS = '/v1/obituary/wreath:thanks'
export const OBITUARY_COUPLET_THANKS = '/v1/obituary/couplet:thanks'
export const OBITUARY_THANKS_LIST_BY_ItemID = '/v1/obituary/thanks'
export const OBITUARY_THANKS_LIST_BY_THANKSID = '/v1/obituary/thanks/{thanksId}'
export const OBITUARY_LIST = '/v1/obituaries'
export const OBITUARY_WREATHS = '/v1/obituary/wreaths'
export const OBITUARY_COUPLETS = '/v1/obituary/couplets'
export const OBITUARY_PREVIEW_COUPLET = '/v1/obituary/couplet:preview'

export const OBITUARY_DELETE_WREATH = '/v1/obituary/wreath:delete'
export const OBITUARY_DELETE_COUPLET = '/v1/obituary/couplet:delete'
export const OBITUARY_SET_LIFE_PRIVILEGE = '/v1/obituary:setLifePrivilege'
export const OBITUARY_CREATE_LIFE = '/v1/obituary:createLife'
export const OBITUARY_OPEN_LIST = '/v1/obituary/open'
export const OBITUARY_CREATE_ORDER_NATIVE = '/v1/obituary:createOrderNative'

export const OBITUARY_CREATE_ORDER_JS = '/v1/obituary:createOrderJS'
export const TEST_CHECK_SUBSCRIBE_ALL = '/v1/test/:checkSubscribeAll'
export const OBITUARY_REPORT_ERROR = '/v1/obituary/alertMap'
export const SET_MEMBER_PAID = '/v1/obituary:setMemberPaid'

export const IGNORE_AUTH_PATHS = [
  USER_SEND_CODE,
  USER_REGISTER,
  USER_LOGIN,
  USER_LOGIN_BY_CODE,
  USER_MODIFY_PASSWORD,
  MEMORIAL_INVITATION
]

const KEY_CLIENT_TYPE = 'key_client_type'

export const CLIENT_TYPE_WEB = 0
export const CLIENT_TYPE_WECHAT = 1
export const CLIENT_TYPE_MINIPROGRAM = 5
export const CLIENT_TYPE_OBITUARY = 6 // 讣告环境

export const ALTAR_CREATE = '/v1/worship/altar:create'
export const ALTAR_DETAIL = '/v1/worship/altar/{id}'
export const ALTAR_SET_TIPS = '/v1/worship:setTips'
export const ALTAR_OFFER = '/v1/worship:offer'
export const ALTAR_GET_TIPS = '/v1/worship/offering-records'
export const ALTAR_MARK_ALL_AS_READ = '/v1/worship/offering-records:markAllAsRead'
export const ALTAR_GET_STATUS = '/v1/worship/altar/{id}/status'
export const ALTAR_GET_FREE_OFFERING = '/v1/worship/altar:setFreeOffering'
export const ALTAR_SET_WORMOSHIP_IN_MEMORIAL = '/v1/worship/altar:setWorshipInMemorial'
export const ALTAR_SET_TIMER_ENABLED = '/v1/worship/altar:setTimerEnabled'
export const ALTAR_SET_AVATAR = '/v1/worship/altar:setAvatar'
export const ALTAR_SET_BGM = '/v1/worship/altar:setBgm'
export const ALTAR_REDUCE_OFFERING = '/v1/worship/debug:reduceStock'
export const ALTAR_INVITATION = '/v1/worship/altar:receiveInvitation'

// portrait
export const DETECT_FACE = '/v1/media:uploadDraftFileAndDetectFace'

//seo
export const FAMILY_NAMES = '/v1/m/familyNames'
export const FAMILY_NAMES_LIVES = '/v1/m/familyName/{name}'
export const PUBLIC_FIGURE_CATEGORIES = '/v1/m/publicFigure/categories'
export const PUBLIC_FIGURE_CATEGORY = '/v1/m/publicFigure/category/{key}'
export const OBITUAYR_OPEN = '/v1/obituary/open/period'
export const ARTICLE_OPEN = '/v1/article/open'

// SSR-safe: detect WeChat from request User-Agent header
function isInWechatSSR(): boolean {
  if (import.meta.server) {
    try {
      const headers = useRequestHeaders(['user-agent'])
      const ua = (headers['user-agent'] || '').toLowerCase()
      return ua.includes('micromessenger')
    } catch {
      return false
    }
  }
  return isInWechat()
}

function isInMiniProgramSSR(): boolean {
  if (import.meta.server) {
    try {
      const headers = useRequestHeaders(['user-agent'])
      const ua = (headers['user-agent'] || '').toLowerCase()
      return ua.includes('miniprogram') || ua.includes('mini program')
    } catch {
      return false
    }
  }
  if (typeof navigator === 'undefined') return false
  const ua = navigator.userAgent.toLowerCase()
  return ua.includes('miniprogram') || ua.includes('mini program')
}

function detectDefaultClientType(): number {
  if (isInMiniProgramSSR()) return CLIENT_TYPE_MINIPROGRAM
  if (isInWechatSSR()) return CLIENT_TYPE_WECHAT
  return CLIENT_TYPE_WEB
}

let _clientTypeCookie: Ref<number> | null = null

export const clientType = {
  __v_isRef: true,
  get value() {
    const nuxtApp = tryUseNuxtApp()
    if (!nuxtApp) return detectDefaultClientType()
    const cookie = useCookie<number>(STORAGE_KEY_CLIENT_TYPE, { readonly: true })
    const detectedClientType = detectDefaultClientType()
    if (cookie.value == null) return detectedClientType
    if (
      (cookie.value === CLIENT_TYPE_WECHAT || cookie.value === CLIENT_TYPE_MINIPROGRAM) &&
      (detectedClientType === CLIENT_TYPE_WECHAT || detectedClientType === CLIENT_TYPE_MINIPROGRAM) &&
      cookie.value !== detectedClientType
    ) {
      return detectedClientType
    }
    return cookie.value
  },
  set value(val: number) {
    if (import.meta.server || !_clientTypeCookie) {
      const cookie = useCookie<number>(STORAGE_KEY_CLIENT_TYPE, { watch: false })
      if (import.meta.server) {
        cookie.value = val
        return
      }
      _clientTypeCookie = cookie
    }
    _clientTypeCookie.value = val
  }
} as unknown as Ref<number>
export const PORTRAIT_CREATE_ORDER_WECHATJS = '/v1/portrait/order:createWechat'
export const PORTRAIT_CREATE_ORDER_WECHATQR = '/v1/portrait/order:createWechatNative'
export const PORTRAIT_ENHANCE_PLANS = '/v1/photo/enhance/plans'
export const PORTRAIT_CREATE_TASK = '/v1/photo/enhance/task:create'
export const PORTRAIT_TASK_NODE_DETAIL = '/v1/photo/enhance/task/node/{nodeId}'
export const PORTRAIT_LIST_MATERIAL = '/v1/photo/enhance/materials'
export const PORTRAIT_PHOTO_BEAUTIFY = '/v1/photo/enhance/task/node:beautify'
export const PORTRAIT_SELECT_NODE_AND_ORDER = '/v1/photo/enhance/task/node:selectAndOrder'
export const PORTRAIT_HOME = '/v1/photo/enhance/home'
export const PORTRAIT_PAY_BY_COIN = '/v1/photo/enhance/task:payByMissbean'
export const PORTRAIT_PAY_BY_MEMBER = '/v1/photo/enhance/task:payByCredit'
export const PORTRAIT_TASK_DETAIL = '/v1/photo/enhance/task/{taskId}'
export const PORTRAIT_TASKS_ME = '/v1/photo/enhance/tasks/me'
export const PORTRAIT_TASKS_OPEN = '/v1/photo/enhance/tasks'
export const PORTRAIT_TASK_DELETE = '/v1/photo/enhance/task/{id}'
export const PORTRAIT_TASK_RETRY = '/v1/photo/enhance/task:retry'
export const PORTRAIT_TASK_SHARE = '/v1/photo/enhance/task:share'
export const PORTRAIT_DETECT_FACES = '/v1/media:detectFaces'
export const PORTRAIT_SET_TRANSPARENT = '/v1/photo/enhance:setTransparent'
export const PORTRAIT_MERGE_BACKGROUND = '/v1/photo/enhance:mergeBackground'
export const PORTRAIT_CAPTURE = '/v1/photo/enhance:capture?lastNodeId={nodeId}'
export const PORTRAIT_MAKE_HD = '/v1/photo/enhance:makeHd'
export const PORTRAIT_COLORIZE = '/v1/photo/enhance:colorize'
export const PORTRAIT_ADJUST_GESTURE = '/v1/photo/enhance:adjustGesture'
export const PORTRAIT_ENHANCE_PLANS_SCENE = '/v1/photo/enhance/plan/{scene}'
export const PORTRAIT_ENHANCE_LAYOUT = '/v1/photo/enhance:layout'
export const PORTRAIT_ENHANCE_NODE_DETAIL = '/v1/photo/enhance/task/node/{nodeId}'
export const PORTRAIT_ADVICE = '/v1/photo/enhance/task/node:advice'
export const PORTRAIT_SELECT_NODE = '/v1/photo/enhance/task/node:select'
export const OBITUARY_PAY_BY_CREDIT = '/v1/obituary:payByCredit'
export const PAY_CREATE_ORDER_WECHATJS = '/v1/pay/order:createJS'
export const PAY_CREATE_ORDER_WECHATQR = '/v1/pay/order:createNative'

//lantern
export const LANTERN_ACTIVITY = '/v1/blessing/activity/{id}'
export const LANTERN_ACTIVITY_JOIN = '/v1/blessing/activity:join'
export const LANTERN_ACTIVITY_BLESSING_CREATE = '/v1/blessing/activity/{id}/blessing:create'
export const LANTERN_ACTIVITY_BLESSING_LIST = '/v1/blessing/activity/{id}/blessing'
export const LANTERN_ACTIVITY_CHECK = '/v1/blessing/activity/{id}/check'

export class CommonResponse<T> {
  code: number
  message: string
  data: T

  constructor(data: T, message: string, code: number = 0) {
    this.data = data
    this.message = message
    this.code = code
  }
}

// idea from https://medium.com/@olinoles/supercharge-vue-3-with-a-reusable-usefetch-client-with-typescript-7019a5a281fa
const networkFetchClient = createFetch({
  baseUrl: () => getAppHost(),
  combination: 'chain',
  options: {
    beforeFetch({ options }) {
      // 加一个
      if (options != null) {
        const isServer = typeof window === 'undefined'
        const token = currentUser?.value?.token?.accessToken
        const langValue = currentLang.value || 'zh_CN' // 默认值保护
        const clientTypeValue = clientType.value || CLIENT_TYPE_WEB // 默认值保护

        options.headers = {
          'Content-Type': 'application/json;charset=utf-8',
          Accept: 'application/json',
          lang: `${langValue}`,
          public: `{ "clientType": ${clientTypeValue} }`
        }

        if (token) {
          // @ts-ignore
          options.headers.Authorization = `Bearer ${token}`
        }
      }
      return { options }
    },
    afterFetch(ctx) {
      // if the response contains a data property, return it
      // if (ctx.data) {
      // }
      return ctx
    },
    onFetchError(ctx) {
      if (ctx.error && ctx.response) {
        const resp = ctx.response as Response
        handleStatus(resp)
      }
      return ctx
    }
  },
  fetchOptions: {
    mode: 'cors'
  }
})

const networkFormClient = createFetch({
  baseUrl: () => getAppHost(),
  combination: 'chain',
  options: {
    beforeFetch({ options, cancel }) {
      // 加一个
      if (options != null) {
        const isServer = typeof window === 'undefined'
        const token = currentUser?.value?.token?.accessToken
        const langValue = currentLang.value || 'zh_CN'
        const clientTypeValue = clientType.value || CLIENT_TYPE_WEB

        options.headers = {
          // 'Content-Type': 'multipart/form-data;',
          Accept: 'application/json',
          lang: `${langValue}`,
          public: `{ "clientType": ${clientTypeValue} }`
        }

        if (token) {
          // @ts-ignore
          options.headers.Authorization = `Bearer ${token}`
        }
      }
      return { options, cancel }
    },
    afterFetch(ctx) {
      // if the response contains a data property, return it
      // if (ctx.data) {
      //   return ctx.data
      // }
      return ctx
    },
    onFetchError(ctx) {
      if (ctx.error && ctx.response) {
        const resp = ctx.response as Response
        handleStatus(resp)
      }
      return ctx
    }
  },
  fetchOptions: {
    mode: 'cors'
  }
})

export type HttpMethod = 'get' | 'post' | 'put' | 'patch' | 'delete' | 'options'

class NetworkClient {
  networkClient: typeof networkFetchClient
  formClient: typeof networkFormClient

  constructor(networkClient: typeof networkFetchClient, formClient: typeof networkFormClient) {
    this.networkClient = networkClient
    this.formClient = formClient
  }

  private get<T>(url: string) {
    return this.networkClient(url, {
      timeout: MAX_TIMEOUT
    })
      .get()
      .json<T>()
  }

  private post<T>(url: string, body: unknown) {
    return this.networkClient(url, {
      timeout: MAX_TIMEOUT
    })
      .post(body)
      .json<T>()
  }

  private patch<T>(url: string, body: unknown) {
    return this.networkClient(url, {
      timeout: MAX_TIMEOUT
    })
      .patch(body)
      .json<T>()
  }

  private delete<T>(url: string, body: unknown) {
    return this.networkClient(url, {
      timeout: MAX_TIMEOUT
    })
      .delete(body)
      .json<T>()
  }

  private options<T>(url: string, body: unknown) {
    return this.networkClient(url, {
      timeout: MAX_TIMEOUT
    })
      .options(body)
      .json<T>()
  }

  async formPut<T>(url: string, body: FormData) {
    return this.formClient(url, {
      timeout: MAX_UPLOAD_TIMEOUT
    })
      .put(body)
      .json<T>()
  }

  async request<T>(url: string, method: HttpMethod, params: Record<string, any>) {
    if (method === 'get') {
      const _url = new URL(getAppHost() + url)
      _url.search = new URLSearchParams(params).toString()
      const finalUrl = _url.toString()
      return this.get<T>(finalUrl)
    } else if (method === 'post') {
      return this.post<T>(url, params)
    } else if (method === 'patch') {
      return this.patch<T>(url, params)
    } else if (method === 'delete') {
      return this.delete<T>(url, params)
    } else if (method === 'options') {
      return this.options<T>(url, params)
    } else {
      // default post
      return this.post<T>(url, params)
    }
  }
}

export const netClient = new NetworkClient(networkFetchClient, networkFormClient)
